import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card my-3"
}
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "card-px text-center py-20 my-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2x fw-bolder mb-10" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 fs-4 fw-bold mb-10" }, " Thank you for submitting your profile. A member of the team will review your profile and respond shortly. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Continue", -1)
const _hoisted_7 = {
  key: 1,
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid",
  id: "kt_create_account_stepper",
  ref: "verticalWizardRef"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center bg-white rounded justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px me-9\"><div class=\"px-6 px-lg-10 px-xxl-15 py-20 d-lg-block d-none\"><div class=\"stepper-nav\"><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">1</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Images</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">2</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Upload Pitch Deck</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">3</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Business Description</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">4</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Business Details</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">5</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Advance Assurance</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">6</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Team Members</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">7</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Industry Sectors</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">8</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Funding Round</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">9</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Find Experts</h3></div></div></div></div></div>", 1)
const _hoisted_9 = { class: "d-flex flex-row-fluid flex-center bg-white rounded" }
const _hoisted_10 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_11 = { "data-kt-stepper-element": "content" }
const _hoisted_12 = { "data-kt-stepper-element": "content" }
const _hoisted_13 = { "data-kt-stepper-element": "content" }
const _hoisted_14 = { "data-kt-stepper-element": "content" }
const _hoisted_15 = { "data-kt-stepper-element": "content" }
const _hoisted_16 = { "data-kt-stepper-element": "content" }
const _hoisted_17 = { "data-kt-stepper-element": "content" }
const _hoisted_18 = { "data-kt-stepper-element": "content" }
const _hoisted_19 = { class: "d-flex flex-stack pt-10" }
const _hoisted_20 = { class: "mr-2" }
const _hoisted_21 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_23 = ["data-kt-indicator"]
const _hoisted_24 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_26 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_27 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = ["data-kt-indicator", "disabled"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_34 = { class: "svg-icon svg-icon-4 ms-1 me-0" }
const _hoisted_35 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Images = _resolveComponent("Images")!
  const _component_UploadPitchDeck = _resolveComponent("UploadPitchDeck")!
  const _component_BusinessDescription = _resolveComponent("BusinessDescription")!
  const _component_BusinessDetails = _resolveComponent("BusinessDetails")!
  const _component_AdvancedAssurance = _resolveComponent("AdvancedAssurance")!
  const _component_TeamMembers = _resolveComponent("TeamMembers")!
  const _component_IndustrySectorsBusinesses = _resolveComponent("IndustrySectorsBusinesses")!
  const _component_FundingRound = _resolveComponent("FundingRound")!
  const _component_FindExperts = _resolveComponent("FindExperts")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_ctx.showSuccess)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createVNode(_component_router_link, {
              to: "/add-role",
              as: "button",
              type: "button",
              class: "btn btn-primary"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("form", {
            class: "py-20 w-100 px-9",
            novalidate: "novalidate",
            id: "kt_create_account_form",
            onSubmit: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Images, {
                onFormData: _ctx.setFormDataTemp,
                formDataTemp: _ctx.formDataTemp
              }, null, 8, ["onFormData", "formDataTemp"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_UploadPitchDeck, {
                onLoading: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loading = $event)),
                onFileSizeError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileSizeError = $event)),
                onFormData: _ctx.setFormDataTemp,
                formDataTemp: _ctx.formDataTemp
              }, null, 8, ["onFormData", "formDataTemp"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_BusinessDescription, {
                onFormData: _ctx.setFormDataTemp,
                formDataTemp: _ctx.formDataTemp
              }, null, 8, ["onFormData", "formDataTemp"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_BusinessDetails, {
                onFormData: _ctx.setFormDataTemp,
                formDataTemp: _ctx.formDataTemp
              }, null, 8, ["onFormData", "formDataTemp"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_AdvancedAssurance, {
                onResetTouch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.touchedAdvancedAssurance = $event)),
                touchedAdvancedAssurance: _ctx.touchedAdvancedAssurance,
                onIsSelected: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isSelected = $event)),
                onFormData: _ctx.setFormDataTemp,
                formDataTemp: _ctx.formDataTemp
              }, null, 8, ["touchedAdvancedAssurance", "onFormData", "formDataTemp"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_TeamMembers, {
                onResetTouch: _cache[4] || (_cache[4] = ($event: any) => (_ctx.touched = $event)),
                touchedParent: _ctx.touched,
                onTeamMembersLength: _cache[5] || (_cache[5] = ($event: any) => (_ctx.teamMembersLength = $event)),
                onFormData: _ctx.setFormDataTemp,
                formDataTemp: _ctx.formDataTemp
              }, null, 8, ["touchedParent", "onFormData", "formDataTemp"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_IndustrySectorsBusinesses, {
                onIndustrySectorsLength: _cache[6] || (_cache[6] = ($event: any) => (_ctx.industrySectorsLength = $event)),
                onResetTouch: _cache[7] || (_cache[7] = ($event: any) => (_ctx.touchedIndustrySector = $event)),
                touchedParent: _ctx.touchedIndustrySector,
                onFormData: _ctx.setFormDataTemp,
                formDataTemp: _ctx.formDataTemp
              }, null, 8, ["touchedParent", "onFormData", "formDataTemp"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_FundingRound, {
                onOpensAtAdded: _cache[8] || (_cache[8] = ($event: any) => (_ctx.opensAtAdded = $event)),
                onClosesAtAdded: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closesAtAdded = $event)),
                onAreDatesValid: _cache[10] || (_cache[10] = ($event: any) => (_ctx.areDatesValid = $event)),
                onFormData: _ctx.setFormDataTemp,
                formDataTemp: _ctx.formDataTemp
              }, null, 8, ["onFormData", "formDataTemp"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_FindExperts)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-lg me-3",
                  "data-kt-stepper-action": "previous",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args))),
                  style: {"color":"#ffffff","background-color":"#236db5"}
                }, [
                  _createElementVNode("span", _hoisted_21, [
                    _createVNode(_component_inline_svg, {
                      src: "media/icons/duotune/arrows/arr063.svg",
                      style: {"color":"#ffffff"}
                    })
                  ]),
                  _hoisted_22
                ])
              ]),
              _createElementVNode("div", null, [
                (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      "data-kt-indicator": _ctx.loading ? 'on' : null,
                      type: "button",
                      class: "btn btn-lg me-3",
                      "data-kt-stepper-action": "submit",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.formSubmit())),
                      style: {"color":"#ffffff","background-color":"#236db5"}
                    }, [
                      (!_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("span", _hoisted_26, [
                              _createVNode(_component_inline_svg, {
                                src: "media/icons/duotune/arrows/arr064.svg",
                                style: {"color":"#ffffff"}
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _hoisted_30))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_23))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      "data-kt-indicator": _ctx.loading ? 'on' : null,
                      type: "submit",
                      class: "btn btn-lg",
                      style: {"color":"#ffffff","background-color":"#236db5"},
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleTouch && _ctx.handleTouch(...args))),
                      disabled: _ctx.loading
                    }, [
                      (!_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                            _hoisted_33,
                            _createElementVNode("span", _hoisted_34, [
                              _createVNode(_component_inline_svg, {
                                src: "media/icons/duotune/arrows/arr064.svg",
                                style: {"color":"#ffffff"}
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, _hoisted_38))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_31))
              ])
            ])
          ], 32)
        ])
      ], 512))
}